import { Translator } from '../../types/ApiResponseTypes'
import { Deal, DealList } from '@/types/deal/deal'
import { DealResponse, isDealListResponse } from '@/types/deal/dealResponse'

class DealResponseTranslator implements Translator<DealList> {
  convert(response: any): DealList {
    if (isDealListResponse(response)) {
      const dealObject: Array<Deal> = []
      if (Array.isArray(response)) {
        response.forEach((deal: DealResponse) => {
          dealObject.push(this.convertToDealModel(deal))
        })
        return { total: response.total, page: response.page, deals: dealObject }
      }
    }
    return { total: 0, page: 0, deals: [] }
  }

  convertToDealModel(response: DealResponse): Deal {
    return {
      id: response.dealId,
      date: response.date,
      company: response.company,
      companyNumber: response.companyNumber,
      address: response.address,
      solutions: response.solution,
      solutionOther: response.solutionOther,
      description: response.description,
      status: response.status,
      name: response.name,
      ticketId: response.ticketId,
      claimedUntil: response.claimedUntil,
      accountManager: response.accountManager,
    }
  }
}
export default new DealResponseTranslator()
